// Copyright (C) Siemens AG 2026. All rights reserved. Confidential

import { createReducer, on } from "@ngrx/store";
import { UserListActions, UserListActionTypes, ProjectListActions, ProjectListActionTypes, InitializeCoreData, IdentitySuccess, IdentityFailure } from "../actions/app.actions"
import { IdentityState } from "../app.state";

export function userListReducer(state: string = "", action: UserListActions) {
    switch (action.type) {
        case UserListActionTypes.Update: {
            return action.payload;
        }

        default:
            return state;

    }
}

export function projectListReducer(state: string = "", action: ProjectListActions) {
    switch (action.type) {
        case ProjectListActionTypes.UpdateProjects: {
            return action.payload;
        }

        default:
            return state;

    }
}

const initialIdentityState: IdentityState = {identity: null, status: null, error: false, idToken: ''}
export const identityStateReducer = createReducer<IdentityState>(
    initialIdentityState,
    on(InitializeCoreData, (state, {payload}) => {return {identity: null, status: 'not-checked', error: false, idToken: payload.idToken}}),
    on(IdentitySuccess, (state, {payload}) => { return {...state, identity: payload, status: 'checked', error: false}}),
    on(IdentityFailure, (state, {}) => {return {...state, identity: null, status: 'checked', error: true}})
);